import React, { useEffect, useState } from "react";
import { Button, Grid, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, FormControl, Select, MenuItem, Box, InputLabel, CircularProgress, TablePagination } from "@mui/material";
import * as XLSX from "xlsx";
import api from "../service/Api";
import Processo from "../components/Processo";

export default function Home() {
    const [responsaveis, setResponsaveis] = useState([]);
    const [areas, setAreas] = useState([]);
    const [originalProcessos, setOriginalProcessos] = useState([]);
    const [filteredProcessos, setFilteredProcessos] = useState([]);
    const [selectedArea, setSelectedArea] = useState('');
    const [selectedResponsavel, setSelectedResponsavel] = useState('');
    const [selectedProcesso, setSelectedProcesso] = useState('');
    const [showTable, setShowTable] = useState(false);
    const [openProcessoDialog, setOpenProcessoDialog] = useState(false);
    const [processoDetalhe, setProcessoDetalhe] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    useEffect(() => {
        const getDados = async () => {
            try {
                const responseAreas = await api.get('api/areas');
                const responseRep = await api.get('api/responsaveis');
                const responseProc = await api.get('api/processos');
                console.log(responseProc);
                setOriginalProcessos(responseProc.data);
                setFilteredProcessos(responseProc.data);
                setAreas(responseAreas.data);
                setResponsaveis(responseRep.data);
            } catch (error) {
                console.error('Erro ao obter os dados: ', error);
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        getDados();
    }, []);

    const filterProcessos = (areaId, responsavelId, processoId) => {
        const filtered = originalProcessos.filter(processo => {
            if (areaId && processo.areas_selecionadas && !processo.areas_selecionadas.includes(areaId)) {
                return false;
            }
            if (responsavelId && processo.responsavel && !processo.responsavel.includes(responsavelId)) {
                return false;
            }
            if (processoId && processo.id !== processoId) {
                return false;
            }
            return true;
        });
        setFilteredProcessos(filtered);
        setShowTable(true);
        setPage(0);
    };

    const handleAreaChange = async (event) => {
        const areaId = event.target.value;
        setSelectedArea(areaId);
        try {
            const responseRep = await api.get('api/responsaveis');
            let responsaveisFiltrados = responseRep.data;
            if (areaId) {
                responsaveisFiltrados = responsaveisFiltrados.filter(responsavel => responsavel.area_de_atuacao_id === areaId);
            }
            setResponsaveis(responsaveisFiltrados);
        } catch (error) {
            console.error('Erro ao filtrar responsáveis: ', error);
            setError(error.message);
        }
        filterProcessos(areaId, selectedResponsavel, selectedProcesso);
    };

    const handleResponsavelChange = (event) => {
        const responsavelId = event.target.value;
        setSelectedResponsavel(responsavelId);
        filterProcessos(selectedArea, responsavelId, selectedProcesso);
    };

    const handleProcessoChange = (event) => {
        const processoId = event.target.value;
        setSelectedProcesso(processoId);
        filterProcessos(selectedArea, selectedResponsavel, processoId);
    };

    const handleSearch = () => {
        filterProcessos(selectedArea, selectedResponsavel, selectedProcesso);
    };

    const handleClear = () => {
        setSelectedArea('');
        setSelectedResponsavel('');
        setSelectedProcesso('');
        setFilteredProcessos(originalProcessos);
        setShowTable(false);
    };

    const handleProcessoClick = (processo) => {
        setProcessoDetalhe(processo);
        setOpenProcessoDialog(true);
    };

    const handleCloseProcessoDialog = () => {
        setOpenProcessoDialog(false);
        setProcessoDetalhe(null);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const exportToExcel = () => {
        const formattedData = filteredProcessos.map(processo => {
            // Cria uma cópia do objeto sem os campos 'id', 'areas_selecionadas' e 'responsavel'
            const { id, areas_selecionadas, responsavel, areas_com_acesso, ...rest } = processo;
            return {
                ...rest,
                areas_com_acesso: Array.isArray(rest.areas_com_acesso) ? rest.areas_com_acesso.join(', ') : rest.areas_com_acesso,
                areas_com_acesso_nome: Array.isArray(rest.areas_com_acesso_nome) ? rest.areas_com_acesso_nome.join(', ') : rest.areas_com_acesso_nome,
                areas_selecionadas_nome: Array.isArray(rest.areas_selecionadas_nome) ? rest.areas_selecionadas_nome.join(', ') : rest.areas_selecionadas_nome,
                dados_pessoais_tratados: Array.isArray(rest.dados_pessoais_tratados) ? rest.dados_pessoais_tratados.join(', ') : rest.dados_pessoais_tratados,
                desc_sensiveis: Array.isArray(rest.desc_sensiveis) ? rest.desc_sensiveis.join(', ') : rest.desc_sensiveis,
                responsavel_nome: Array.isArray(rest.responsavel_nome) ? rest.responsavel_nome.join(', ') : rest.responsavel_nome,
                dados_sensiveis: rest.dados_sensiveis === 1 ? 'sim' : 'não',
                dados_menor: rest.dados_menor === 1 ? 'sim' : 'não',
                dados_menor_sensiveis: rest.dados_menor_sensiveis === 1 ? 'sim': 'não',
                compartilhamento_externo: rest.compartilhamento_externo === 1 ? 'sim' : 'não',
                transferencia_internacional: rest.transferencia_internacional === 1 ? 'sim' : 'não'
            };
        });
    
        const ws = XLSX.utils.json_to_sheet(formattedData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Processos");
        XLSX.writeFile(wb, "processos.xlsx");
    };
    
    if (loading) {
        return (
            <Grid container justifyContent="center" alignItems="center" style={{ minHeight: '100vh' }}>
                <CircularProgress />
            </Grid>
        );
    }

    if (error) {
        return (
            <Grid container justifyContent="center" alignItems="center" style={{ minHeight: '100vh' }}>
                <Typography color="error">Error: {error}</Typography>
            </Grid>
        );
    }

    const filteredProcessosForSelect = originalProcessos.filter(processo => {
        if (selectedArea && processo.areas_selecionadas && !processo.areas_selecionadas.includes(selectedArea)) {
            return false;
        }
        if (selectedResponsavel && processo.responsavel && !processo.responsavel.includes(selectedResponsavel)) {
            return false;
        }
        return true;
    });

    return (
        <Box height="100%" display="flex" alignItems="center" justifyContent="center">
            <Grid container spacing={2} style={{ maxWidth: "800px", marginTop: 5 }}>
                <Grid item xs={12} display="flex" justifyContent="space-between" flexDirection={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'stretch', sm: 'center' }} gap={2}>
                    <Typography variant="h7" sx={{ border: '1px solid rgb(25,118,210)', padding: 1, borderRadius: 2 }}>Número de Registros: {originalProcessos.length}</Typography>
                    <Button size="medium" href="/formulario" variant="contained">Cadastrar novo processo</Button>
                    <Button size="medium" variant="contained" onClick={exportToExcel}>Exportar para Excel</Button>
                </Grid>
                <Grid item xs={12}>
                    <FormControl fullWidth>
                        <InputLabel id="area-atuacao-label">Área de Atuação</InputLabel>
                        <Select
                            labelId="area-atuacao-label"
                            value={selectedArea}
                            onChange={handleAreaChange}
                            displayEmpty
                        >
                            {areas.map((area) => (
                                <MenuItem key={area.id} value={area.id}>
                                    {area.nome}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <FormControl fullWidth>
                        <InputLabel id="responsavel-label">Responsável</InputLabel>
                        <Select
                            labelId="responsavel-label"
                            value={selectedResponsavel}
                            onChange={handleResponsavelChange}
                            displayEmpty
                        >
                            {responsaveis.map((responsavel) => (
                                <MenuItem key={responsavel.id} value={responsavel.id}>
                                    {responsavel.nome}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <FormControl fullWidth>
                        <InputLabel id="processos-label">Processos</InputLabel>
                        <Select
                            labelId="processos-label"
                            value={selectedProcesso}
                            onChange={handleProcessoChange}
                            displayEmpty
                        >
                            {filteredProcessosForSelect
                                .sort((a, b) => a.processo.localeCompare(b.processo))
                                .map((processo) => (
                                    <MenuItem key={processo.id} value={processo.id}>
                                        {processo.processo}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} display="flex" justifyContent="space-between">
                    <Button variant='contained' onClick={handleSearch}>Pesquisar</Button>
                    <Button variant='outlined' onClick={handleClear}>Limpar Campos</Button>
                </Grid>
                {showTable && (
                    <Grid item xs={12}>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ textAlign: 'center' }}>Processo</TableCell>
                                        <TableCell>Área de Atuação</TableCell>
                                        <TableCell>Responsável</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredProcessos.length > 0 ? (
                                        filteredProcessos
                                            .sort((a, b) => a.areas_selecionadas_nome.localeCompare(b.areas_selecionadas_nome))
                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((processo) => (
                                                <TableRow key={processo.id}>
                                                    <TableCell>
                                                        <Button variant="text" size="small" onClick={() => handleProcessoClick(processo)} sx={{ textAlign: 'left' }}>
                                                            {processo.processo}
                                                        </Button>
                                                    </TableCell>
                                                    <TableCell>{processo.areas_selecionadas_nome}</TableCell>
                                                    <TableCell>{processo.responsavel_nome}</TableCell>
                                                </TableRow>
                                            ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={3}>Nenhum processo encontrado.</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                            <TablePagination
                                rowsPerPageOptions={[10, 25, 50]}
                                component="div"
                                count={filteredProcessos.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                labelRowsPerPage="Processos por página:"
                            />
                        </TableContainer>
                    </Grid>
                )}
            </Grid>
            {processoDetalhe && (
                <Processo
                    open={openProcessoDialog}
                    handleClose={handleCloseProcessoDialog}
                    processo={processoDetalhe}
                />
            )}
        </Box>
    );
}
